export default __webpack_public_path__ + "static/media/gruapluma.24913e4d.png";